'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = undefined;

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _dec2, _class;

var _components = require('components');

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _auth = require('redux/modules/auth');

var _reactTable = require('react-table');

var _reactTable2 = _interopRequireDefault(_reactTable);

var _reduxConnect = require('redux-connect');

var _reactRedux = require('react-redux');

var _account = require('redux/modules/account');

var _contacts = require('redux/modules/contacts');

var _reachHistory = require('../../../helpers/reachHistory');

var _email = require('redux/modules/email');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = require('./PushSingle.scss');
var md = {
	person: require('react-icons/lib/md/person')
};

var PushSingle = (_dec = (0, _reduxConnect.asyncConnect)([{
	key: "auth",
	promise: function promise(_ref) {
		var _ref$store = _ref.store,
		    dispatch = _ref$store.dispatch,
		    getState = _ref$store.getState;

		if (!(0, _auth.isLoaded)(getState())) {
			return dispatch((0, _auth.load)());
		}
		return null;
	}
}]), _dec2 = (0, _reactRedux.connect)(function (state) {
	return {
		auth: state.auth
	};
}, { getContacts: _contacts.getContacts, getAccount: _account.getAccount, sendEmail: _email.sendEmail, push: _reachHistory.push }), _dec(_class = _dec2(_class = function (_Component) {
	(0, _inherits3.default)(PushSingle, _Component);

	function PushSingle(props) {
		(0, _classCallCheck3.default)(this, PushSingle);

		var _this = (0, _possibleConstructorReturn3.default)(this, (PushSingle.__proto__ || (0, _getPrototypeOf2.default)(PushSingle)).call(this, props));

		_this.renderChips = function (contacts) {
			var chips = [];
			contacts.map(function (contact) {
				chips.push(_react2.default.createElement(
					'div',
					{ className: styles.chip },
					_react2.default.createElement(
						'div',
						{ className: styles.chipContent },
						_this.displayTokenOrWhatever(contact)
					),
					_react2.default.createElement(
						'div',
						{ className: styles.chipClose, onClick: function onClick() {
								return _this.handleSelection(contact);
							} },
						_react2.default.createElement(
							'svg',
							{ className: styles.chipSvg, focusable: 'false',
								viewBox: '0 0 24 24', 'aria-hidden': 'true' },
							_react2.default.createElement('path', { d: 'M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm5 13.59L15.59 17 12 13.41 8.41 17 7 15.59 10.59 12 7 8.41 8.41 7 12  10.59 15.59 7 17 8.41 13.41 12 17 15.59z' })
						)
					)
				));
			});
			_this.setState({ chips: chips });
		};

		_this.displayTokenOrWhatever = function (contact) {
			var value = null;
			var push_tokens = contact.push_tokens;

			if (contact.profile.first_name || contact.profile.last_name) {
				var first_name = contact.profile.first_name ? contact.profile.first_name.value : '';
				var last_name = contact.profile.last_name ? contact.profile.last_name.value : '';
				value = first_name + ' ' + last_name;
			} else {
				value = push_tokens[0].substring(0, 8);
			}
			return value;
		};

		_this.isIn = function (value) {
			var foundIt = _this.state.selected.find(function (contact) {
				return contact.id == value.id;
			});
			return foundIt ? true : false;
		};

		_this.state = {
			contactList: [],
			selected: [],
			chips: [],
			message: '',
			reachAccount: null,
			recipients: [],
			redirectTo: _this.props.push
		};
		return _this;
	}

	(0, _createClass3.default)(PushSingle, [{
		key: 'componentDidMount',
		value: function componentDidMount() {
			var _this2 = this;

			var contactList = [];
			this.props.getContacts({ main_identifier: 'push_tokens' }).then(function (data) {
				if (data) {
					data.map(function (element) {
						if (element.push_tokens.length > 0) {
							contactList.push(element);
						}
					});
				}
				_this2.setState({ contactList: contactList });
			});
			this.props.getAccount().then(function (data) {
				return _this2.setState({ reachAccount: data });
			});
		}
	}, {
		key: 'handleSelection',
		value: function handleSelection(value) {
			var _this3 = this;

			var prevSelected = this.state.selected;
			var recipients = this.state.recipients;
			var index = prevSelected.findIndex(function (contact) {
				return contact.id === value.id;
			});
			if (index == -1) {
				var _recipients;

				prevSelected.push(value);
				recipients = (_recipients = recipients).concat.apply(_recipients, (0, _toConsumableArray3.default)(value.push_tokens));
			} else {
				prevSelected.splice(index, 1);
				recipients.splice(index, 1);
			}
			this.setState({ selected: prevSelected, recipients: recipients }, function () {
				return _this3.renderChips(prevSelected);
			});
		}
	}, {
		key: 'handleMessage',
		value: function handleMessage(text) {
			this.setState({ message: text });
		}
	}, {
		key: 'sendMessage',
		value: function () {
			var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
				var redirectTo, account_uid, channels, recipients, push_channel, dataToSend, responseEmail;
				return _regenerator2.default.wrap(function _callee$(_context) {
					while (1) {
						switch (_context.prev = _context.next) {
							case 0:
								redirectTo = this.state.redirectTo;
								account_uid = this.state.reachAccount;
								channels = this.state.reachAccount.reach.channels;
								recipients = this.state.recipients;
								push_channel = null;

								push_channel = channels.find(function (channel) {
									return channel.type == 'PUSH';
								});
								dataToSend = {
									text: this.state.message,
									event: 'SINGLE',
									message_type: 'PUSH',
									profile_alias: recipients[0],
									channel_type: 'PUSH',
									created_by: this.props.auth.data.user.email,
									channel_identifier: push_channel.identifier,
									recipients: recipients,
									account_uid: account_uid._id
								};
								_context.next = 9;
								return this.props.sendEmail(dataToSend);

							case 9:
								responseEmail = _context.sent;

								if (responseEmail[0][0] == 500) {

									redirectTo({
										pathname: '/fail',
										state: {
											goTo: '/push/single',
											goToModal: false,
											message: 'Ha ocurrido un error',
											modal: true,
											returnTo: '/push'
										}
									});
								} else {
									redirectTo({
										pathname: '/success',
										state: {
											goTo: '/push/single',
											goToModal: false,
											message: 'Se envió correctamente el mensaje',
											modal: true,
											returnTo: '/push'
										}
									});
								}

							case 11:
							case 'end':
								return _context.stop();
						}
					}
				}, _callee, this);
			}));

			function sendMessage() {
				return _ref2.apply(this, arguments);
			}

			return sendMessage;
		}()
	}, {
		key: 'render',
		value: function render() {
			var _this4 = this;

			var columns = [{
				id: 'push_tokens',
				accessor: 'push_tokens',
				filterable: true,
				Cell: function Cell(props) {
					return _react2.default.createElement(_components.CarrierIcon, { profile: props.original, detail: true, push: true });
				}
				// Filter: ({ filter, onChange }) => (
				// 	<input
				// 		onChange={event => onChange(event.target.value) }
				// 		value={filter ? filter.value : ''}
				// 		placeholder={'Buscar'}
				// 	/>
				// ),
			}];

			return _react2.default.createElement(
				'div',
				{ className: styles.pushSingleContainer },
				_react2.default.createElement(
					'div',
					{ className: styles.selectContact },
					_react2.default.createElement(
						'div',
						{ className: styles.table },
						_react2.default.createElement(_reactTable2.default, {
							columns: columns,
							data: this.state.contactList
							// filterable
							, defaultFilterMethod:
							// (filter, row) => {
							// 	console.log(filter)
							// 	console.log(row)
							// 	// String(row[filter.msisdn]) === filter.value
							// }
							function defaultFilterMethod(filter, row) {
								return String(row.push_tokens[0]).includes(filter.value);
							}
							// (filter, row) => filter.value.includes(row.msisdn)
							// String(row[filter.id]) === filter.value
							,
							getTrProps: function getTrProps(state, rowInfo) {
								if (rowInfo && rowInfo.row) {
									return {
										onClick: function onClick(e) {
											_this4.handleSelection(rowInfo.original);
										},
										style: {
											background: _this4.isIn(rowInfo.original) ? '#BEC4D0' : 'white',
											fontWeight: _this4.isIn(rowInfo.original) ? 'bold' : 'unset',
											color: _this4.isIn(rowInfo.original) ? '#060D3B' : 'black',
											cursor: 'pointer'
										}
									};
								} else {
									return {};
								}
							}
						})
					)
				),
				_react2.default.createElement(
					'div',
					null,
					_react2.default.createElement(
						'div',
						{ className: styles.chipContainer },
						_react2.default.createElement(
							'span',
							{ className: styles.span },
							this.state.chips.length > 0 ? _react2.default.createElement(
								'span',
								{ style: { marginTop: '10px', marginLeft: '4px' } },
								'Enviar a:'
							) : _react2.default.createElement(
								'h3',
								null,
								'SELECCIONA CONTACTO DESTINO'
							),
							this.state.chips
						)
					),
					_react2.default.createElement(
						'div',
						null,
						_react2.default.createElement('textarea', { onChange: function onChange(event) {
								return _this4.handleMessage(event.target.value);
							}, className: styles.messageArea,
							placeholder: 'Escribe tu mensaje aqu\xED' })
					),
					_react2.default.createElement(
						'div',
						{ style: { textAlign: 'end', marginRight: '36px' } },
						_react2.default.createElement(_components.Button, { className: styles.sendMessage, color: 'green', name: 'Enviar ahora', onClick: function onClick() {
								return _this4.sendMessage();
							} })
					)
				)
			);
		}
	}]);
	return PushSingle;
}(_react.Component)) || _class) || _class);
exports.default = PushSingle;
module.exports = exports['default'];